var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('span',[_vm._v("© 2005－2020 小橙家教 蜀ICP备2022026614号")])])
}]

export { render, staticRenderFns }